import type { Socket } from 'socket.io-client'
import {
  SOCKET_EVENTS,
  type PrivateRoomListPayload,
  type PrivateRoomRow,
} from '@shared/index'
import { createAppSocket } from './createAppSocket'
import { releasePresenceHold } from './presenceHold'

export type RoomBrowserHandlers = {
  onList: (rooms: PrivateRoomRow[]) => void
  onError?: (message: string) => void
}

/**
 * Socket for the private-rooms page. Separate from the duel socket so a
 * waiting host can still list rooms in another tab.
 */
export class RoomBrowserClient {
  private readonly socket: Socket

  constructor(handlers: RoomBrowserHandlers) {
    this.socket = createAppSocket()
    this.socket.on('connect', () => {
      this.socket.emit(SOCKET_EVENTS.ROOM_BROWSER_JOIN)
    })
    this.socket.on(
      SOCKET_EVENTS.ROOM_BROWSER_LIST,
      (payload: PrivateRoomListPayload) => {
        handlers.onList(payload?.rooms ?? [])
      },
    )
    this.socket.on('connect_error', (err: Error) => {
      handlers.onError?.(err.message || 'connect_error')
    })
  }

  dispose(): void {
    releasePresenceHold(this.socket)
    this.socket.emit(SOCKET_EVENTS.ROOM_BROWSER_LEAVE)
    this.socket.removeAllListeners()
    this.socket.disconnect()
  }
}
